import React, { createContext, useContext } from 'react';
import { message as antdMessage } from 'antd';

const MessageContext = createContext({ showMessage: () => {} });

const MessageProvider = ({ children }) => {
    const [messageApi, contextHolder] = antdMessage.useMessage();

    const showMessage = (type = 'info', content = 'Info', duration = 3) => {
        messageApi.open({ type, content, duration });
    };

    return (
        <MessageContext.Provider value={{ showMessage }}>
            {contextHolder}
            {children}
        </MessageContext.Provider>
    );
};

export default MessageProvider;
export const useMessage = () => useContext(MessageContext);